import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"

const authUser = localStorage.getItem("authUser");
const filterAuth = JSON.parse(authUser);
const permissions = filterAuth?.adminDetail?.permissions;
const authType = filterAuth?.adminDetail?.type;
const token = localStorage.getItem("token") || null;

console.log(filterAuth?.adminDetail);

const checkPermission = (title) => {
  if (authType === 'admin') return true;
  else {
    switch (title) {
      case "Dashboard":
        return permissions?.dashboard || false;
      case "User Management":
        return permissions?.usermanagement?.allAccess || false;
      case "Banner Management":
        return permissions?.bannerManagement?.allAccess || false;
      case "Category Management":
        return permissions?.categoryManagement?.allAccess || false;
      case "Block Management":
        return permissions?.HomeBlockManagement?.allAccess || false;
      case "Product Management":
        return permissions?.productManagement?.allAccess || false;
      case "Role Management":
        return false;
      case "Support Management":
        return permissions?.supportManagement?.allAccess || false;
      case "FAQ Management":
        return permissions?.faqsManagement?.allAccess || false;
      case "Order Management":
        return permissions?.orderManagement?.allAccess || false;
      case "Warehouse Management":
        return permissions?.warehouseManagement?.allAccess || false;
      default:
        return false;
    }
  }
};
// PrivateRoute for permission-based routing
const PrivateRoute = ({ component: Component, title, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      checkPermission(title) ? (
        <Component {...props} />
      ) : (
        <>
          {!authType === 'admin' &&
            <Redirect to="/dashboard" />
          }
        </>
      )
    }
  />
);

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  title,
  ...rest
}) => (
  <>
    <PrivateRoute title={title} component={Component} {...rest}>
      <Route
        {...rest}
        render={(props) => {
          // Your previous commented-out logic can go here if needed for future use
          if (isAuthProtected && !checkPermission(title)) {
            return (
              <Redirect
                to={{ pathname: "/dashboard", state: { from: props.location } }}
              />
            );
          }

          return (
            <Layout>
              <Component {...props} />
            </Layout>
          );
        }}
      />
    </PrivateRoute>
    <Route
      render={(props) => {
        if (!token) {
          return (
            <Redirect
              to={{ pathname: "/login" }}
            />
          );
        }
      }}
    />
  </>
);


// Authmiddleware.propTypes = {
//   isAuthProtected: PropTypes.bool,
//   component: PropTypes.any,
//   location: PropTypes.object,
//   layout: PropTypes.any,
// }

export default Authmiddleware
